import React from 'react';

import { useTranslation } from '../i18n';
import { lapseHint } from '../lib/format';

/**
 * How close a term is to lapsing, in words, beside the date itself.
 *
 * A date alone makes an operator subtract: «۱۴۰۴/۰۶/۲۵ — is that soon?». The hint
 * answers that without replacing the date, because the date is the fact and the
 * hint is the reading.
 *
 * Deliberately ABSENT for a term with months left. A list where every row carries
 * a coloured hint has no hints — the colour budget (DESIGN-CONCEPT §10) says
 * semantic colour is spent only on what demands attention, and a healthy
 * subscription demands none.
 *
 * Never colour alone: the words carry the meaning and the tint reinforces it, so
 * the column survives being printed, being read by somebody with a colour vision
 * deficiency, and being scanned at arm's length.
 */
const TONE_CLASS = {
  warn: 'text-[#92400E]',
  danger: 'text-destructive',
};

export default function LapseHint({ date, now }) {
  const { t } = useTranslation();
  const hint = lapseHint(date, { t, now });
  if (!hint) return null;

  return (
    <span className={`text-[11px] ${TONE_CLASS[hint.tone] || 'text-muted-foreground'}`}>
      {hint.text}
    </span>
  );
}
